var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGavelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 100,
    viewBox: "0 0 96 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5516",
    "data-name": "Rectangle 5516",
    width: 96,
    height: 100,
    fill: "#f5f5f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9995",
    "data-name": "Group 9995",
    opacity: 0.16,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28960",
    "data-name": "Path 28960",
    d: "M89.206,77.68,69.576,58.037l21.177-21.19L110.385,56.49,89.206,77.68",
    transform: "translate(-49.411 -26.161)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28961",
    "data-name": "Path 28961",
    d: "M167.761,142.235l7.309-7.323c2.029,1.8,4.133,3.665,6.235,5.533q15.443,13.724,30.879,27.456a8.15,8.15,0,1,1-11.414,11.553c-3.312-3.683-6.581-7.4-9.869-11.109q-11.267-12.7-22.534-25.392c-.215-.242-.418-.5-.606-.719",
    transform: "translate(-119.141 -95.787)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28962",
    "data-name": "Path 28962",
    d: "M27.813,309.508q-12.361,0-24.721,0c-2.379,0-3.082-.714-3.082-3.113,0-1.628-.032-3.256.021-4.882a6.608,6.608,0,0,1,6.514-6.4q21.306-.045,42.612,0a6.671,6.671,0,0,1,6.615,6.556c.055,1.662.02,3.326.015,4.99-.007,2.015-.816,2.85-2.819,2.853q-9.379.015-18.758,0h-6.4",
    transform: "translate(0 -209.51)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28963",
    "data-name": "Path 28963",
    d: "M25.362,263.687c0-1.191-.054-2.277.01-3.355a6.6,6.6,0,0,1,6.489-6.325q14.04-.087,28.08,0a6.645,6.645,0,0,1,6.482,6.575c.025,1.008,0,2.016,0,3.1Z",
    transform: "translate(-17.997 -180.312)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28964",
    "data-name": "Path 28964",
    d: "M37.755,108.568a4.78,4.78,0,0,1,3.513,1.458q10.4,10.389,20.773,20.8a5.018,5.018,0,1,1-7.066,7.126q-10.429-10.357-20.782-20.789a5.019,5.019,0,0,1,3.562-8.594",
    transform: "translate(-23.201 -77.083)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28965",
    "data-name": "Path 28965",
    d: "M146.273,0A4.725,4.725,0,0,1,149.8,1.415q10.435,10.426,20.847,20.876a5.013,5.013,0,0,1-7.064,7.113q-10.5-10.435-20.93-20.947a4.676,4.676,0,0,1-.971-5.423A4.763,4.763,0,0,1,146.273,0",
    transform: "translate(-100.294 0.001)",
    fill: "#f5f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavelIcon);
export default __webpack_public_path__ + "static/media/GavelIcon.49a440a7a2a101228393ffd6ec5237d2.svg";
export { ForwardRef as ReactComponent };